import { Box, Button, InputBase, Modal, TextField, Typography, Tooltip, IconButton } from "@mui/material";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from '@mui/icons-material/Search';
import { InventoryBatchTable } from "../../sub_components/inventoryBatchTable";
import { updateInventoryBatchModal, updateInventoryDetail, updateinventoryDetailsEdit, updateInventoryDetailsModal } from "../../Redux/inventory";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import RemoveCircleOutlineOutlinedIcon from '@mui/icons-material/RemoveCircleOutlineOutlined';
import { OrderDetailsModal } from "../globalFunctions";



export function InventoryBatchList() {
    const toast = useRef(null)
    const product = useSelector(state => state.inventory.selectedInventoryId)
    const inventoryBatchForm = useSelector(state => state.inventory.inventoryBatchForm)
    const totalOrdered = useSelector(state => state.inventory.totalOrdered)
    const available = useSelector(state => state.inventory.available)
    const [formData, setFormData] = useState([]);
    console.log(formData)
    const dispatch = useDispatch()
    const user_role = localStorage.getItem('role');
    useEffect(() => {
        setFormData(inventoryBatchForm)
    }, [inventoryBatchForm])
    const handleOpen = () => {
           dispatch(updateInventoryDetail({
               batch:[{
                   product_id: "",
                   available_units: "",
                   units: "",
                   total_units: "",
                   expired_on: null,
                   expire_alert: null,
                   bogo_enabled:false,
                   quantity: "",
               }
               ],
               place: "",
               supervisor_ids: [
                   0
               ],
               details_id: '',
               purchased_on: null,
               supplier: '',
               invoice: '',
               batch_no:'',
           }));
           dispatch(updateinventoryDetailsEdit(false));
           dispatch(updateInventoryDetailsModal(true))
       };

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "20px", width: "100%", padding: "30px" }}>
            <Toast ref={toast} />
            <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                <Typography sx={{ fontSize: "16px", fontWeight: "700", lineHeight: "24px" }}>Product Management</Typography>
                <Typography sx={{ fontSize: "14px", fontWeight: "500", lineHeight: "22px" }}>Inventory / View Batch</Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%", alignItems: "center" }}>
                <Box>
                    <Typography sx={{ fontSize: "20px", fontWeight: "500", lineHeight: "28px" }}>{product.item_name}</Typography>
                    <Typography sx={{ fontSize: "14px", fontWeight: "400", lineHeight: "22px" }}>{product.item_category}</Typography>
                </Box>

                <Box sx={{ height: "94px", maxWidth: "445px", width: "100%", backgroundColor: "white", display: "flex", alignItems: "center" }}>
                    <Box sx={{ width: "100%" }}>
                        <Typography sx={{ fontSize: { sm: "24px", md: "24px" }, fontWeight: "500", lineHeight: "32px", textAlign: "center"}}>{totalOrdered}</Typography>
                        <Typography sx={{ fontSize: { sm: "14px", md: "14px" }, fontWeight: "400", lineHeight: "22px", textAlign: "center" }}>Total Ordered </Typography>
                    </Box>
                    <Box sx={{ width: "100%" }}>
                        <Typography sx={{ fontSize: { sm: "24px", md: "24px" }, fontWeight: "500", lineHeight: "32px", textAlign: "center" }}>{available}</Typography>
                        <Typography sx={{ fontSize: { sm: "14px", md: "14px" }, fontWeight: "400", lineHeight: "22px", textAlign: "center",color:"borders.green"  }}>Available</Typography>
                    </Box>
                    {/* <Box sx={{ width: "100%" }} >
                        <Typography sx={{ fontSize: { sm: "24px", md: "24px" }, fontWeight: "500", lineHeight: "32px", textAlign: "center" }} >xxxx</Typography>
                        <Typography sx={{ fontSize: { sm: "14px", md: "14px" }, fontWeight: "400", lineHeight: "22px", textAlign: "center" }}>Expired</Typography>
                    </Box> */}
                </Box>
            </Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", width: "100%" }}>
                <Box sx={{ position: "relative" }}>
                    <InputBase sx={{ backgroundColor: "white", height: "32px", width: "100%", maxWidth: "268px", borderRadius: "2px", border: "1px solid", borderColor: "secondary.border", padding: "5px 12px 5px 40px", fontSize: "14px", fontWeight: "400", lineHeight: "22px", color: "black" }} placeholder="Search item" />
                    <SearchIcon sx={{ position: "absolute", left: "12px", top: "5px", width: "20px", height: "20px" }} />
                </Box>
                <Box sx={{ display: "flex", gap: "20px" }}>
                    {user_role !== 'customer_engagement_admin' && <Button variant="contained" onClick={handleOpen} sx={{ textTransform: "none" }}> Add Items</Button>}
                </Box>
            </Box>
            <InventoryBatchTable />
            <OrderDetailsModal/>
        </Box>

    )
}